// GiftCategory.js
import { connect } from 'react-redux';
import GiftCategory from '../component/GiftCategory.jsx';

import fetchGifts from '../action/fetchGifts.js';
import getListData from '../selector/getListData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getGiftPreviewMeta from '../selector/getGiftPreviewMeta.js';

function mapStateToProps(state, { category }) {
  const selectPath = ['gift', 'item', category];
  const nextPage = getListData(state, selectPath, 'nextPage');
  const itemIds = getListData(state, selectPath, 'itemIds');
  const firstGiftId = itemIds && itemIds[0];
  return {
    itemIds,
    isFetched: !!getNetworkingData(state, [...selectPath, 1], 'isFetched'),
    isFirstPageFetching: !!getNetworkingData(
      state,
      [...selectPath, 1],
      'isFetching'
    ),
    isNextPageFetching: !!getNetworkingData(
      state,
      [...selectPath, nextPage],
      'isFetching'
    ),
    nextPage,
    firstGiftMeta: firstGiftId ? getGiftPreviewMeta(state, firstGiftId) : null,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchGifts: ({ category, page }) =>
      dispatch(fetchGifts({ category, page })),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GiftCategory);
